import { TranslateService } from "@ngx-translate/core";
import { PasswordComplexityConditionModel } from "../models/pop-up.interface";

const DefaultPasswordComplexity = [
    {
      Id: 1,
      Name: 'MinimumLength',
      Value: 6,
      PasswordConditionDisplayName: null,
      ValidIcon: null
    },
    {
        Id: 2,
        Name: 'MaximumLength',
        Value: 14,
        PasswordConditionDisplayName: null,
        ValidIcon: null
    },
    {
      Id: 3,
      Name: 'SpecialCharacter',
      Value: '',
      PasswordConditionDisplayName: null,
      ValidIcon: null
    },
    {
      Id: 4,
      Name: 'LowerCaseCharacter',
      Value: '',
      PasswordConditionDisplayName: null,      
      ValidIcon: null
    },
    {
      Id: 5,
      Name: 'UpperCaseCharacter',
      Value: '',
      PasswordConditionDisplayName: null, 
      ValidIcon: null
    },
    {
      Id: 6,
      Name: 'NumberAllowed',
      Value: '',
      PasswordConditionDisplayName: null, 
      ValidIcon: null
    }
  ];

export const PasswordComplexityCheck: any = (tenantConfig: any, translateService: TranslateService): Array<PasswordComplexityConditionModel> => {
    try {
        let returnArrayValue: Array<PasswordComplexityConditionModel> = [];
        if (tenantConfig && tenantConfig.length > 0) {
              DefaultPasswordComplexity.forEach((defaultPwd: any) => {                
                tenantConfig.forEach((tenant: any) => {
                  if (tenant.configKey === 'RegularExpression' && defaultPwd.Name === 'SpecialCharacter') {
                    if (tenant.configValue) {
                      defaultPwd.Value = tenant.configValue;
                    }
                  }
                  if (defaultPwd.Name === tenant.configKey) {
                    if (tenant.configValue) {
                      defaultPwd.Value = parseInt(tenant.configValue);
                    }
                  }
                  defaultPwd.PasswordConditionDisplayName = getDisplayName(defaultPwd, tenant, translateService);
                });
          });
        } else {
          DefaultPasswordComplexity.forEach((defaultPwd: any) => { 
            defaultPwd.PasswordConditionDisplayName = getDisplayName(defaultPwd, null, translateService);
          });
        }
        DefaultPasswordComplexity.map(x => x.ValidIcon = null);
        returnArrayValue = [...DefaultPasswordComplexity];
        return returnArrayValue;
    } catch (error) {
        console.error('Error Occured in Password Complexity Check Interface - ', error);
    }
};

function getDisplayName(defaultPwd: any, tenant: any, translateService: TranslateService) {
  try {
    let displayName = translateService.instant('PasswordComplexity.' + defaultPwd.Name);
    if (typeof defaultPwd.Value === 'number') {
      displayName = translateService.instant('PasswordComplexity.haveText') + 
      defaultPwd.Value.toString() + translateService.instant('PasswordComplexity.' + defaultPwd.Name);
    }
    return displayName;
  } catch (error) {
    console.error('Error Occured in Get Display Name - ', error);
  }
}